module.exports = __webpack_public_path__ + "img/MAIA_S.776bf14d.png";